
import React, { memo } from 'react';
import SectionHeading from '../ui/SectionHeading';

interface SubsectionHeadingProps {
  content: string;
  index: number;
}

const SubsectionHeading: React.FC<SubsectionHeadingProps> = ({ content, index }) => {
  return (
    <SectionHeading 
      key={index}
      text={content} 
      level="h3"
      className="my-4 text-base font-medium text-gray-200"
    />
  );
};

export default memo(SubsectionHeading);
